export const innerPopupTypes={
  SUCCESS: 'success',
  ERROR: 'error',
}

export const kosherOrAflaloStatusTypes={
  OPEN : 'OPEN ',
  BLOCK  : 'BLOCK',
}

export const templateCodeTypes={
  VOUCHER_VOICE: 'VOUCHER_VOICE',
  VOUCHER_SMS: 'VOUCHER_SMS',
}
